<div class="flex-column height-100 bg-col-w"
     [style]="client.isS || client.isM ? 'border-top-left-radius: 12px; border-top-right-radius: 12px;' : ''">
    <div class="p-a-4-s p-a-4-m p-a-5-l p-a-5-x b-b b-col-5">
        <div class="flex flex-justify-between">
            <div class="flex flex-middle">
                <p class="h3">{{'Cart' | translate}}</p>
                <p class="s1 p1-s p1-m col-11 m-l-2">{{(basket.qty === 1 ? '% item' : '% items') | translate :
                    basket.qty}}</p>
            </div>
            <button role="button"
                    aria-label="Close"
                    (click)="close()">
                <i class="icon-close"
                   aria-hidden="true"></i>
            </button>
        </div>
    </div>



    <!-- content -->
    <div class="overflow-auto custom-scrollbar flex-grow p-l-5 p-r-5 p-l-4-s p-r-4-s p-l-4-m p-r-4-m"
         cy-minibasketView>

        @if (basket.qty) {
        <div>
            <!-- customer info -->
            @if(content?.basketCustomerInfo && client.sizeId > 1) {
            <div class="bg-col-62 col-1 m-t-5-x m-t-5-l b-a b-col-63"
                 style="border-radius: 12px;">
                <p class="p-a center s2"
                   *iCms="'basketCustomerInfo' of content; skipEmpty true">
                </p>
            </div>
            }
            <!-- basket items -->
            @for (item of basket.items; track item.id;) {
            <basket-view-item class="block"
                              [class.b-b]="!$last"
                              [item]="item"
                              [context]="'minibasket'"
                              cy-minibasketItem />
            }
        </div>
        }
        <!-- empty -->
        @if (!basket.qty) {
        <div cy-basketEmpty
             class="center p2 col-1">
            {{'Your cart is empty' | translate}}
        </div>
        }

    </div>

    <!-- bottom part -->
    @if (basket.qty) {
    <div class="w-12 p-l-5 p-r-5 p-t-3 p-b-3 p-l-4-s p-r-4-s p-t-3-s p-t-3-m p-l-4-m p-r-4-m b-t b-col-5">
        <!-- totals -->
        <basket-view-totals [onlyTotal]="true"
                            class="block" />

        <!-- submission -->
        <minibasket-submit class="block m-t-2-l m-t-2-x m-b-2" />
        <!-- accepted payments -->
        <p *iCms="'footerNote' of content || []; skipEmpty true"
           class="p2 col-1 center"></p>
    </div>
    }

</div>